import React from 'react';

import cssClasses from './../cssClasses';

const Separator = () => <div className={cssClasses.SEPARATOR} />;

export default Separator;



// WEBPACK FOOTER //
// ./src/Component/Separator.js